import {
  Exercise,
  Level,
  SessionSequenceEntry,
  WorkoutSettings,
} from '../../../../entities';
import { homeTransistionSequenceForRest } from '../homeSharedSequenceEntries';
import { SequenceContentEntryBuilder } from '../sequenceContentEntryBuilder';
import { EquipmentInstructions } from '../setupinstructions/equipmentinstructions';

export class TransitionForRestWithBenchInstruction extends SequenceContentEntryBuilder {
  public build(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAlternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
  ): SessionSequenceEntry {
    return {
        ...homeTransistionSequenceForRest(
            this.transitionDuration,
            zone,
            quarter,
          ),
          homeBenchInstructionImageUrl: EquipmentInstructions.setupBenchInstructionImageUrl(exercise),
          equipmentWeightInfo: exercise.equipmentWeightInfo,
    };
  }
}
